import React from 'react';
import ProductInquiryCard from '../../components/ProductInquiryCard';

const BondsFDs = () => {
  const instruments = [
    {
      title: "Senior Secured Corporate Bonds",
      yieldRate: "9.2% – 11.5% p.a.",
      rating: "CRISIL / ICRA AA & AAA",
      desc: "Collateralized debt obligations with first-charge security over tangible assets and predictable semi-annual or annual coupon payouts."
    },
    {
      title: "Sovereign Gold Bonds (SGB) & G-Secs",
      yieldRate: "7.1% – 7.5% + Capital Appreciation",
      rating: "Sovereign / Central Govt",
      desc: "Guaranteed by the Reserve Bank of India with absolute sovereign safety, regular semi-annual coupon yields, and indexation tax benefits."
    },
    {
      title: "High-Yield Corporate Fixed Deposits",
      yieldRate: "8.5% – 9.6% p.a.",
      rating: "AAA & AA+ Rated NBFCs",
      desc: "Higher yield accruals than conventional bank deposits, with flexible monthly, quarterly, or cumulative interest payout mandates."
    }
  ];

  return (
    <div className="min-h-screen bg-[#07131F] text-slate-100 selection:bg-[#16325B] selection:text-white pb-20">
      <section className="relative pt-20 pb-16 px-4 sm:px-6 lg:px-8 border-b border-slate-800/80 overflow-hidden text-center">
        <div className="absolute inset-0 pointer-events-none opacity-20 bg-[radial-gradient(#3B82F6_1px,transparent_1px)] [background-size:24px_24px]"></div>
        <div className="max-w-5xl mx-auto relative z-10">
          {/* <div className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full bg-[#16325B]/40 border border-blue-500/30 text-[#60A5FA] text-xs sm:text-sm font-semibold mb-6">
            <span className="w-2 h-2 rounded-full bg-[#60A5FA] animate-pulse"></span>
            Fixed Yield & Institutional Capital Preservation
          </div> */}
          <h1 className="text-3xl sm:text-5xl lg:text-6xl font-serif font-bold text-white tracking-tight leading-tight">
            Bonds, NCDs & <span className="text-[#60A5FA]">Corporate FDs</span>
          </h1>
          <p className="mt-4 text-base sm:text-lg text-slate-300 max-w-2xl mx-auto leading-relaxed">
            Lock in inflation-beating, predictable annual yields through AAA/AA-rated institutional fixed income securities and collateralized debentures.
          </p>
        </div>
      </section>

      <section className="py-10 bg-[#091B2C] border-b border-slate-800">
        <div className="max-w-5xl mx-auto px-4 grid grid-cols-1 sm:grid-cols-3 gap-6 text-center">
          <div className="p-4 bg-[#0B1E30]/60 rounded-xl border border-slate-700/50">
            <div className="text-xs uppercase text-slate-400 font-semibold tracking-wider">Target Fixed Yield</div>
            <div className="text-2xl font-bold text-[#60A5FA] font-mono mt-1">8.5% – 11.5%</div>
          </div>
          <div className="p-4 bg-[#0B1E30]/60 rounded-xl border border-slate-700/50">
            <div className="text-xs uppercase text-slate-400 font-semibold tracking-wider">Credit Ratings</div>
            <div className="text-2xl font-bold text-white font-serif mt-1">CRISIL / ICRA AA & AAA</div>
          </div>
          <div className="p-4 bg-[#0B1E30]/60 rounded-xl border border-slate-700/50">
            <div className="text-xs uppercase text-slate-400 font-semibold tracking-wider">Minimum Entry</div>
            <div className="text-2xl font-bold text-blue-300 font-mono mt-1">₹10,000+</div>
          </div>
        </div>
      </section>

      <section className="py-16 px-4 sm:px-6 lg:px-8 max-w-6xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-7 space-y-5">
            <h2 className="text-2xl sm:text-3xl font-serif font-bold text-white mb-6">
              Curated Fixed Income Instruments
            </h2>
            {instruments.map((item, idx) => (
              <div
                key={idx}
                className="p-6 rounded-2xl bg-[#0B1E30]/80 backdrop-blur-sm border border-slate-700/60 hover:border-blue-500/50 hover:shadow-lg hover:shadow-blue-500/10 hover:-translate-y-1 transition-all duration-300"
              >
                <div className="flex justify-between items-start mb-2 gap-4">
                  <h3 className="font-bold text-white text-lg sm:text-xl">{item.title}</h3>
                  <span className="text-xs px-3 py-1 bg-[#16325B]/40 text-[#60A5FA] border border-blue-500/30 rounded-full font-mono font-bold shrink-0">
                    {item.yieldRate}
                  </span>
                </div>
                <p className="text-xs sm:text-sm text-slate-300 leading-relaxed mb-3">{item.desc}</p>
                <div className="text-[11px] text-slate-400 font-medium">
                  Verified Credit Assessment: <strong className="text-[#60A5FA] font-semibold">{item.rating}</strong>
                </div>
              </div>
            ))}
          </div>

          <div className="lg:col-span-5 sticky top-24">
            <ProductInquiryCard
              title="Request Live Bond Inventory"
              subtitle="Receive current coupon schedules, tranche availability, and credit reports."
              productName="Bonds, NCDs & Corporate FDs"
              defaultTicket="₹10,000 to ₹1,00,000"
              buttonText="Get Live Yield Sheet"
            />
          </div>
        </div>
      </section>
    </div>
  );
};

export default BondsFDs;